<div class="container">
    <div class="tw-text-xl md:tw-text-3xl tw-font-extrabold tw-text-center tw-capitalize">Corporate Lease Products</div>
    <p class="tw-pt-4 tw-pb-10 tw-text-center tw-text-sm md:tw-text-base tw-leading-relaxed">Tailored Leasing Solutions
        for Corporate Mobility Needs</p>

    <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-center tw-gap-8">
        <div class="tw-p-8 tw-rounded-lg tw-shadow tw-bg-[#F7B703]/[0.1] tw-w-full "
            *ngFor="let cardData of businessPlan">
            <div class="tw-text-lg md:tw-text-xl tw-font-bold tw-pb-1">{{cardData.cardHead}}</div>
            <div class="tw-text-sm md:tw-text-base tw-font-semibold tw-text-grayDark">{{cardData.subheading}}</div>
            <ul class=" tw-pt-3 tw-h-[6rem]" *ngFor="let points of cardData.listPoints">
                <span><fa-icon [icon]="faCheck" class="fa-xl tw-text-grayMid"></fa-icon>
                    <li class="tw-leading-loose md:tw-leading-relaxed tw-text-xs md:tw-text-sm">{{points}}</li>
                </span>
            </ul>
            <div class="tw-mt-10 md:tw-mt-12">
                <a type="button" href="contact-us"
                    class="tw-rounded-md tw-bg-pinkDark tw-px-4 tw-py-2 tw-text-white  tw-text-xs md:tw-text-sm tw-font-bold hover:tw-text-white">
                    Get in touch &nbsp;<fa-icon [icon]="faArrowRight"></fa-icon>
                </a>
            </div>
        </div>
    </div>
    <div class="tw-text-sm tw-p-10 tw-text-center tw-leading-relaxed">
        All of the above offerings include Zero Dep Insurance, End - End Maintenance, and Damage handling along with
        24x7 RSA and free pick up & drop for both planned/ unplanned maintenance / service.
    </div>
</div>